import request from "@/utils/request";

export function getPayments(page = 1)
{
    return request({
        url: "/payments",
        method: "get",
        params: {
            page
        },
        showLoader: true,
        withoutErrorMessages: true
    });
}

export function getPaymentMethods()
{
    return request({
        url: "/payment_methods",
        method: "get",
        showLoader: true,
        withoutErrorMessages: true
    });
}

export function storePaymentMethod(payment_method_id)
{
    return request({
        url: "/payment_methods",
        method: "post",
        data: {
            payment_method_id
        },
        withoutErrorMessages: true
    });
}

export function setPaymentMethodAsDefault(payment_method_id)
{
    return request({
        url: `/payment_methods/${payment_method_id}`,
        method: "put",
    });
}

export function deletePaymentMethod(payment_method_id)
{
    return request({
        url: `/payment_methods/${payment_method_id}`,
        method: "delete",
    });
}

export function getCardSessionId()
{
    return request({
        url: "/payment_methods/card_session_id",
        method: "get",
        showLoader: true,
        withoutErrorMessages: true
    });
}
